'use client';

import React, { createContext, useContext, useState, useEffect } from 'react';
import { getPermissionMapping } from './permissionMapping';
import { getCookie } from '../API/interceptor';

type AccessControl = {
  [key: string]: { [key: string]: { R: string } };
};

type PermissionContextType = {
  permissions: {
    success: boolean;
    access_controls: AccessControl;
  } | null;
  loading: boolean;
};

const PermissionContext = createContext<PermissionContextType>({ permissions: null, loading: true });

export function PermissionProvider({ children }: { children: React.ReactNode }) {
  const [permissions, setPermissions] = useState<PermissionContextType['permissions']>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPermissions = async () => {
      setLoading(true); // Start loading

      try {
        // Replace this with your actual API endpoint
        //const response = await fetch('/api/access');
        // const data = await response.json();
        const token = getCookie('accessToken');
        const pr_url = `${process.env.REACT_APP_GLOBAL_API_URL}/settings/access-controls/`;
        const pr_key = process.env.REACT_APP_PERMISSION_KEY;
        const product_code = process.env.REACT_APP_PRODUCT_CODE;
        const response = await fetch(pr_url, {
          method: 'POST',
          headers: {
                      'Content-Type': 'application/json',
                      'Authorization': `Bearer ${token}`
                    },
          body: JSON.stringify({
            "product_code": product_code,
            "token": token
          })
        });
        const data = await response.json();
        if (data.statusCode == '200') {
          setPermissions(data.body);
        } else {
          console.error('Error fetching permissions');
        }
      } catch (error) {
        console.error('Error fetching permissions:', error);
      }
      finally {
        setLoading(false); // End loading
      }
    };

    fetchPermissions();
  }, []);

  return (
      <PermissionContext.Provider value={{ permissions,loading  }}>
        {children}
      </PermissionContext.Provider>
  );
}
export const getProductCode = () => {
  return process.env.REACT_APP_PRODUCT_CODE || '8';
};
export function usePermission(permissionKey: string): boolean | 'loading' {
  const { permissions,loading  } = useContext(PermissionContext);
  if (loading) return 'loading';

  const mapping = getPermissionMapping(permissionKey);
  if (!permissions || !permissions.success || !mapping) return false; //For Demo Env Uncomment this Line
 // if (!permissions || !permissions.success || !mapping) return true;   // For Local Env Uncomment this Line (dont push this)


  const controller = permissions.access_controls[mapping.controller];
  if (!controller) return false; //For Demo Env Uncomment this Line
  //if (!controller) return true;  // For Local Env Uncomment this Line (dont push this)


  return !!controller[mapping.function];  // For Demo Env Uncomment this Line
  //return true; // For Local Env Uncomment this Line (dont push this)
}